import { render } from "./HomepageSectionEditView.vue?vue&type=template&id=c5be3412&scoped=true"
import script from "./HomepageSectionEditView.vue?vue&type=script&lang=js"
export * from "./HomepageSectionEditView.vue?vue&type=script&lang=js"

import "./HomepageSectionEditView.vue?vue&type=style&index=0&id=c5be3412&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5be3412"]])

export default __exports__